export default __webpack_public_path__ + "static/media/github.987334e9.png";